export { default } from './UppercaseLabel'
